/**
 * Apply viewport tooltip policy to a Highcharts options object.
 * @param {Object} options
 * @param {boolean} tooltipsEnabled
 * @returns {Object}
 */
export function applyChartTooltipForViewport(options, tooltipsEnabled) {
  if (!options) return options;
  if (tooltipsEnabled) return options;

  return {
    ...options,
    tooltip: {
      ...(options.tooltip ?? {}),
      enabled: false,
    },
  };
}
